import React, {useState} from 'react';
import Grid from "@material-ui/core/Grid";
import { makeStyles } from '@material-ui/core/styles';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Paper from "@material-ui/core/Paper";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import TableBody from "@material-ui/core/TableBody";
import Chip from "@material-ui/core/Chip";
import Table from "@material-ui/core/Table";
import {withStyles} from "@material-ui/core";
import { numberToKorean } from '../../utils/numberTokorean'

const useStyles = makeStyles(theme => ({
    root: {
        width: '100%'
    },
    formControlLabel: {
        fontFamily: 'Noto Sans KR',
        fontStyle: 'normal',
        fontWeight: 'bold',
        fontSize: '15px'
    },
    button: {
        marginTop: theme.spacing(3),
        marginLeft: theme.spacing(1),
        borderRadius: 15,
        backgroundColor: "#1b6817",
        padding: '5px 30px',
        height: 35,
        fontSize: "15px",
        color: 'white',
        '&:hover': {
            backgroundColor: '#767676',
            color: '#ffffff'
        }
    },
    table: {
        width: '100%',
    },
}));

const addComma = (num) => {
    const regexp = /\B(?=(\d{3})+(?!\d))/g;
    return num.toString().replace(regexp, ',');
};

const getCodeName = (column, value) => {
    if (column === "frorAgreeYn" || column === "familyAplyYn" || column === "intDiviYn" || column === "intYn" || column === "rentYn"
        || column === "optRentYn" || column === "bizYn" || column === "etcYn" || column === "famyObsYn" || column === "famyCareYn"
        || column === "taxAccntYn" || column === "jointYn" || column === "bizRegYn" || column === "rentBizYn" || column === "houseRentYn") {
        if ('1' === value) {
            return '예';
        } else if ('0' === value) {
            return '아니오';
        }
    }

    if ((column === 'rentIncomeAmt' || column === 'rentDepositAmt' || column === 'stdMktAmt' || column === 'ddcArea') && (value !== "" && value !== null && value !== undefined)) {
        return addComma(value);
    } else if (value === null || value === undefined || value === "") {
        return "N/A";
    } else {
        return value;
    }
}

const HouseSummaryAccordion = ({ houseNo, data }) => {
    const classes = useStyles();

    const StyledTableCell = withStyles((theme) => ({
        head: {
            backgroundColor: "#ebeded",
            // color: theme.palette.common.white,
        },
        body: {
            fontSize: 14,
        },
    }))(TableCell);

    return (
        <React.Fragment>
            <Grid container
                  direction="column"
                  alignItems="flex-start"
                  justifyContent="center"
            >
                <div className={classes.root}>
                    <Accordion>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-label="Expand"
                            aria-controls="additional-actions1-content"
                            id="additional-actions1-header"
                        >
                            <Typography>{`[임대 주택${houseNo}] 답변 내역`}</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <Paper style={{overflow: 'hidden', padding: '20px', width: '100%'}}>
                                <Table className={classes.table}>
                                    <TableHead>
                                        <TableRow>
                                            <StyledTableCell>항목</StyledTableCell>
                                            <StyledTableCell>답변</StyledTableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        { data.houseRentYn === "0" ?
                                            <TableRow key={'result_rent_0'}>
                                                <TableCell component="th" scope="row">
                                                    <Chip variant="outlined" label="주택 임대 여부"/>
                                                </TableCell>
                                                <TableCell>{getCodeName("houseRentYn", data.houseRentYn)}</TableCell>
                                            </TableRow>
                                            :
                                            <>
                                            <TableRow key={'result_rent_1'}>
                                            <TableCell component="th" scope="row">
                                                <Chip variant="outlined" label="장부작성 여부"/>
                                            </TableCell>
                                            <TableCell>{getCodeName("taxAccntYn", data.taxAccntYn)}</TableCell>
                                        </TableRow>
                                            <TableRow key={'result_rent_2'}>
                                        <TableCell component="th" scope="row">
                                            <Chip variant="outlined" label="개인세무사 이름"/>
                                        </TableCell>
                                        <TableCell>{getCodeName("taxAccntNm", data.taxAccntNm)}</TableCell>
                                    </TableRow>
                                    <TableRow key={'result_rent_3'}>
                                        <TableCell component="th" scope="row">
                                            <Chip variant="outlined" label="개인세무사 전화번호"/>
                                        </TableCell>
                                        <TableCell>{getCodeName("taxAccntTelno", data.taxAccntTelno)}</TableCell>
                                    </TableRow>
                                    <TableRow key={'result_rent_17'}>
                                      <TableCell component="th" scope="row">
                                        <Chip variant="outlined" label="개인세무사 이메일"/>
                                      </TableCell>
                                      <TableCell>{getCodeName("taxAccntMail", data.taxAccntMail)}</TableCell>
                                    </TableRow>
                                    <TableRow key={'result_rent_4'}>
                                        <TableCell component="th" scope="row">
                                            <Chip variant="outlined" label="임대부동산 이름"/>
                                        </TableCell>
                                        <TableCell>{getCodeName("rentAgentNm", data.rentAgentNm)}</TableCell>
                                    </TableRow>
                                    <TableRow key={'result_rent_6'}>
                                        <TableCell component="th" scope="row">
                                            <Chip variant="outlined" label="부동산 주소"/>
                                        </TableCell>
                                        <TableCell>{getCodeName("rentAgentAddr", data.rentAgentAddr)}</TableCell>
                                    </TableRow>
                                    <TableRow key={'result_rent_7'}>
                                        <TableCell component="th" scope="row">
                                            <Chip variant="outlined" label="부동산 상세주소"/>
                                        </TableCell>
                                        <TableCell>{getCodeName("rentAgentAddrDetls", data.rentAgentAddrDetls)}</TableCell>
                                    </TableRow>
                                    <TableRow key={'result_rent_16'}>
                                      <TableCell component="th" scope="row">
                                        <Chip variant="outlined" label="임대기간 및 보증금"/>
                                      </TableCell>
                                      <TableCell>
                                        {data.rentPeriods ? (
                                          data.rentPeriods.map((period, index) => (
                                            <div key={index}>
                                              {`기간 ${index+1} : `}{period.startDate} ~ {period.endDate}&nbsp; 보증금 : {addComma(String(period.rentDepositAmt).replace(/[^0-9]/g, ''))}
                                              {String(period.rentDepositAmt).replace(/[^0-9]/g, '') && (
                                                <span style={{ marginLeft: 6, color: '#666', fontSize: 12 }}>
                                                  {numberToKorean(String(period.rentDepositAmt).replace(/[^0-9]/g, ''))}
                                                </span>
                                              )}
                                              {index < data.rentPeriods.length - 1 && <br/>}
                                            </div>
                                          ))
                                        ) : (
                                          "N/A"
                                        )}
                                      </TableCell>
                                    </TableRow>
                                    <TableRow key={'result_rent_8'}>
                                        <TableCell component="th" scope="row">
                                            <Chip variant="outlined" label="연간 총 임대수입"/>
                                        </TableCell>
                                      <TableCell>{
                                        <>
                                          {getCodeName('rentIncomeAmt', data.rentIncomeAmt)}
                                          {String(data.rentIncomeAmt).replace(/[^0-9]/g, '') && (
                                            <span style={{ marginLeft: 6, color: '#666', fontSize: 12 }}>
                                                  {numberToKorean(String(data.rentIncomeAmt).replace(/[^0-9]/g, ''))}
                                                </span>
                                          )}
                                        </>
                                      }</TableCell>
                                    </TableRow>
                                    {/*<TableRow key={'result_rent_9'}>*/}
                                    {/*    <TableCell component="th" scope="row">*/}
                                    {/*        <Chip variant="outlined" label="임대보증금액"/>*/}
                                    {/*    </TableCell>*/}
                                    {/*    <TableCell>{getCodeName("rentDepositAmt", data.rentDepositAmt)}</TableCell>*/}
                                    {/*</TableRow>*/}
                                    <TableRow key={'result_rent_10'}>
                                        <TableCell component="th" scope="row">
                                            <Chip variant="outlined" label="공동소유여부"/>
                                        </TableCell>
                                        <TableCell>{getCodeName("jointYn", data.jointYn)}</TableCell>
                                    </TableRow>
                                    <TableRow key={'result_rent_11'}>
                                        <TableCell component="th" scope="row">
                                            <Chip variant="outlined" label="지분비율"/>
                                        </TableCell>
                                        <TableCell>{getCodeName("shareRate", data.shareRate)}</TableCell>
                                    </TableRow>
                                    <TableRow key={'result_rent_12'}>
                                        <TableCell component="th" scope="row">
                                            <Chip variant="outlined" label="기준시가"/>
                                        </TableCell>
                                      <TableCell>{
                                        <>
                                          {getCodeName('stdMktAmt', data.stdMktAmt)}
                                          {String(data.stdMktAmt).replace(/[^0-9]/g, '') && (
                                            <span style={{ marginLeft: 6, color: '#666', fontSize: 12 }}>
                                                  {numberToKorean(String(data.stdMktAmt).replace(/[^0-9]/g, ''))}
                                                </span>
                                          )}
                                        </>
                                      }</TableCell>
                                    </TableRow>
                                    <TableRow key={'result_rent_13'}>
                                        <TableCell component="th" scope="row">
                                            <Chip variant="outlined" label="전용면적 (단위:m²)"/>
                                        </TableCell>
                                        <TableCell>{getCodeName("ddcArea", data.ddcArea)}</TableCell>
                                    </TableRow>
                                    <TableRow key={'result_rent_14'}>
                                        <TableCell component="th" scope="row">
                                            <Chip variant="outlined" label="세무서 임대사업자 등록 여부"/>
                                        </TableCell>
                                        <TableCell>{getCodeName("bizRegYn", data.bizRegYn)}</TableCell>
                                    </TableRow>
                                    <TableRow key={'result_rent_15'}>
                                        <TableCell component="th" scope="row">
                                            <Chip variant="outlined" label="지자체 임대사업자 등록 여부"/>
                                        </TableCell>
                                        <TableCell>{getCodeName("rentBizYn", data.rentBizYn)}</TableCell>
                                    </TableRow>
                                            </>
                                        }
                                    </TableBody>
                                </Table>
                            </Paper>
                        </AccordionDetails>
                    </Accordion>
                </div>
            </Grid>
        </React.Fragment>
    );
};

export default HouseSummaryAccordion;
